module.exports = __webpack_public_path__ + "Roboto-Bold.56a76a220d9c9765946d.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/roboto-fontface/fonts/Roboto/Roboto-Bold.ttf
// module id = 303
// module chunks = 19